document.addEventListener('DOMContentLoaded', function() {
  const popularLinks = document.querySelectorAll('.popular-items li a');
  const headerHeight = document.querySelector('header').offsetHeight + 50;

  popularLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const targetId = this.getAttribute('href');
      const targetElement = document.querySelector(targetId);
      
      if (targetElement) {
        document.querySelectorAll('.faq-container').forEach(container => container.classList.remove('open'));
        document.querySelectorAll('.panel_content').forEach(panel => panel.classList.remove('open'));

        const faqContainer = targetElement.closest('.faq-container');
        const panelContent = targetElement.querySelector('.panel_content');
 
        setTimeout(() => {
          const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });

          setTimeout(() => {
            if (faqContainer) faqContainer.classList.add('open');
            if (panelContent) panelContent.classList.add('open');
          }, 100);
        }, 300);
      }
    });
  });

  const urlParams = new URLSearchParams(window.location.search);
  const searchline = urlParams.get("searchline");
  if (searchline != null && searchline != "") {
    document.querySelector("[data-faq-form] input").value = searchline;
    const faqBlocks = document.querySelectorAll("[data-faq-blocks]");
    let flag = false;

    faqBlocks.forEach(function (block) {
      var text = block.textContent || block.innerText;
      const answer = block.querySelector('[data-faq-answer]');

      text = text.trim().toLowerCase();
      if (text.indexOf(searchline) > -1) {
        block.style.display = "block";
        block.classList.add("open");
        if (answer) {
          answer.classList.add("open");
          flag = false;
        }
      } else {
        block.style.display = "none";
        block.classList.remove("open");
        if (answer) {
          answer.classList.remove("open");
        }
      }
    });
  }
});